
import { IFeedbackHeader, IFeedback } from './feedback.types'

/** class for Feedback */
export class Feedback implements IFeedback {

    feedbackHeaders: Array<FeedbackHeader> 

    transactionId: number

    entity: string

    selectedFeedback: FeedbackHeader
    

    constructor (data: IFeedback) {
    
        this.feedbackHeaders = [];

        this.transactionId = data.transactionId || 0;

        this.entity = data.entity || '';

        this.selectedFeedback = new FeedbackHeader(data.selectedFeedback || ({} as IFeedbackHeader));

        if(data.feedbackHeaders && data.feedbackHeaders.length > 0) {

            data.feedbackHeaders.forEach(x => {
                this.feedbackHeaders.push(new FeedbackHeader(x));
            });
        }
    
    }
}

export class FeedbackHeader implements IFeedbackHeader {

    FeedbackHeaderId: number

    Entity: string

    RowID: number

    RowKey: string

    Section: string

    SectionPart: string

    Resolved: boolean

    Count: number

    AllCount: number

    constructor(data: IFeedbackHeader) {
        this.FeedbackHeaderId = data.FeedbackHeaderId;
        this.Entity = data.Entity;
        this.RowID = data.RowID;
        this.RowKey = data.RowKey;
        this.Section = data.Section;
        this.SectionPart = data.SectionPart;
        this.Resolved = data.Resolved;
        this.Count = data.Count;
        this.AllCount = data.AllCount;
    }
}